module.exports = __webpack_public_path__ + "static/vmno-streaming-now-tallyman.v1-click2sms/files/6da07e5bc02c29b2bfbf580cd688903a.gif";